export default __webpack_public_path__ + "static/media/lightningsparks.760f65eb.png";